/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Tabs from 'ui/Tabs/Tabs';
import Loader from 'ui/Loader/Loader';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import GhanaGov from './tabs/GhanaGov/GhanaGov';
import SSNIT from './tabs/SSNIT/SSNIT';

const tabsOptions = [{ label: 'Ghana Gov' }, { label: 'SSNIT' }];

const BillPayments = () => {
  const [activeTab, setActiveTab] = useState<number | false>(0);
  const [nextTab, setNextTab] = useState<number | false>(0);
  // TODO: loading data to true
  const [loadingData, setLoadingData] = useState(false);
  const [isFormDirty, setFormDirty] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const location = useLocation();

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  useEffect(() => {
    if (downMdScreen) {
      setActiveTab(false);
    } else {
      setActiveTab(nextTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downMdScreen]);

  const actualOptions = downMdScreen && activeTab === false ? tabsOptions.slice(0, 3) : tabsOptions;

  const handleOnChangeTab = useCallback(
    (_event: React.ChangeEvent<unknown>, tabIndex: number) => {
      setActiveTab(tabIndex);
      setNextTab(tabIndex);

      if (isFormDirty) {
        setShowWarning(true);
      }
    },
    [isFormDirty],
  );

  const renderTabs = () => {
    if (downMdScreen && activeTab !== false) {
      return null;
    }

    return (
      <>
        <Tabs value={activeTab} options={actualOptions} onChange={handleOnChangeTab} disabled={loadingData} />
      </>
    );
  };

  const handleClickBack = () => {
    if (isFormDirty) {
      setShowWarning(true);
    } else {
      setActiveTab(false);
    }
  };

  const getTitle = () => {
    if (downMdScreen) {
      if (activeTab !== false) {
        return `${tabsOptions[activeTab].label}`;
      }
    }
    return 'Bills Payment';
  };

  const showTitle = true;

  return (
    <>
      <DashboardCard fullHeight>
        {showTitle && (
          <NavigationTitle
            to="/billPayments"
            layoutType={LayoutType.dashboard}
            onClick={handleClickBack}
            noArrow={activeTab === false}
          >
            {getTitle()}
          </NavigationTitle>
        )}
        {downMdScreen && activeTab === false && <MobileSubtitle>Select Transfer Category</MobileSubtitle>}
        {renderTabs()}
        {loadingData && <Loader />}
        {/* TABS */}
        {!loadingData && activeTab === 0 && <GhanaGov />}
        {!loadingData && activeTab === 1 && <SSNIT />}
      </DashboardCard>
    </>
  );
};

export default BillPayments;
